
import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import AsyncBackdropSubmit from '../../../../components/AsyncBackdropSubmit';
import { IMetadataJSON } from '../../../../components/TemplatesForms/Selector/types';
import { fetchSpecificApplicationForm } from '../../../../lib/fetchers';
import HttpService from '../../../../services/HttpService';
import SpecificFromScratchApplication from '../SpecificFromScratchApplication';

function SmartSpecificFromScratchApplication() {
  const { id } = useParams();
  const [specificForm, setSpecificForm] = React.useState<any>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [isSubmitLoading, setIsSubmitLoading] = React.useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const navigation = useNavigate();
  const fetching = async () => {
    try {
      const specificForm = await fetchSpecificApplicationForm(id as any);
      setIsLoading(false);
      setSpecificForm(specificForm);
    } catch (error: any) {
      console.error(error);
      enqueueSnackbar(t(error?.response?.data?.message) || t('Παρουσιάστηκε κάποιο σφάλμα'), { variant: 'error' });
      if (error.response.status === 404 || error.response.status === 401) 
        navigation('/applications');

    }
  };

  const handleSubmit = async (formData: IMetadataJSON[]) => {
    setIsSubmitLoading(true);
    const body = {
      formFields: formData,
      applicationId: id
    };
    try {
      const form_data = new FormData();
      form_data.append('formFields', JSON.stringify(body));
      formData.map((field) => {
        if (field.propertyType === 'file') {
          form_data.append('file', field?.propertyValue?.[0] as any);
        }
      });

      await HttpService.getAxiosClient().post('/forms/public/applications', form_data);
      enqueueSnackbar('Η αίτηση σας υποβλήθηκε επιτυχώς', { variant: 'success' });
      setIsSubmitLoading(false);
      navigation('/applications');
    } catch (error) {
      console.error(error);
      setIsSubmitLoading(false);
      enqueueSnackbar('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.', { variant: 'error' });

    }
  };

  React.useEffect(() => {
    fetching();
  }, []);

  return <>
    <AsyncBackdropSubmit isLoading={isSubmitLoading}>
      Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
    </AsyncBackdropSubmit>

    <SpecificFromScratchApplication
      onSubmit={handleSubmit}
      formTitle={specificForm?.appl_title_naming?.title}
      form_stacture={specificForm?.form_stacture}
      form_checkBoxes={specificForm?.form_checkBoxes}
      isLoading={isLoading}
    />
  </>;

}

export default SmartSpecificFromScratchApplication;